module.exports = __webpack_public_path__ + "static/img/Terrific.fca88104.png";